module.exports = __webpack_public_path__ + "img/btn.ff074c9a.png";